import { supabase } from '../supabase';

export const DEMO_CALL_URL = 'https://n8n.hireportal.ai/webhook/demo-call';
export const DEMO_CALL_LIMIT = 3;

export const getDemoCallsCount = async (candidateId) => {
  if (!candidateId) return 0;

  const { count, error } = await supabase
    .from('candidates_demo_calls')
    .select('id', { count: 'exact', head: true })
    .eq('candidate_id', candidateId);

  if (error) {
    console.error('Demo calls count failed', error);
    return 0;
  }

  return count || 0;
};

const normalizeDemoCall = (call) => ({
  id: call.id,
  created_at: call.created_at,
  ai_summary: String(call.ai_summary ?? call.summary ?? '').trim(),
  status: call.status ?? null,
  call_duration: call.call_duration ?? null,
});

export const getDemoCandidateCalls = async (candidateId) => {
  if (!candidateId) return [];

  const { data, error } = await supabase
    .from('candidates_demo_calls')
    .select('*')
    .eq('candidate_id', candidateId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return (data ?? []).map(normalizeDemoCall);
};

export const startDemoCall = async ({ candidateId, agentId }) => {
  const response = await fetch(DEMO_CALL_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      candidate_id: candidateId,
      agent_id: agentId,
    }),
  });

  const text = await response.text();
  let data = text;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    // Keep raw text if n8n returns a non-JSON body.
  }

  return {
    ok: response.ok,
    status: response.status,
    data,
  };
};
